export default __webpack_public_path__ + "static/media/fMaltoBuza7.33be5a9f.png";